import React, { useState } from 'react';

const ProfileView = ({children, img, name, date, intro}) => {
    const [showMore, setShowMore] = useState(false);

    const doMore = () => {
        if (showMore) { setShowMore(false) }
        else { setShowMore(true) }
    }

    return (
        <div className='flex-col rounded-lg border-2 border-gray-200 bg-[#fffefa] shadow-xl'>
            <div className='flex flex-col lg:flex-row p-[5px]'>
                <div className='flex-col w-full lg:w-2/5 p-[5px] border-b-2 lg:border-b-0 lg:border-e-2'>
                    <div className="p-[5px] md:p-[5px] text-center align-middle">
                        <h1 className="text-sm md:text-xl font-bold text-[#C94C67]">{name}</h1>
                    </div>
                    <div className='p-[5px] md:p-[5px] flex justify-center items-center'>
                        <img className='w-24 h-24 md:w-48 md:h-48 rounded-full object-cover border-2 border-[#ecbfc9]' src={img} alt='portrait' />
                    </div>
                    <div className="p-[5px] md:p-[5px] text-center align-middle">
                        <h1 className="text-xs md:text-lg">{date}</h1>
                    </div>
                </div>
                <div className='flex-col w-full lg:w-3/5 p-[5px] md:p-[25px]'>
                    <div className="p-[5px]">
                        <p className='text-lg md:text-base text-gray-700'>{intro}</p>
                    </div>
                    <div className="p-[5px] m-[15px] grid justify-items-end">
                        <button class="bg-[#C94C67] hover:bg-[#a03e53] text-white font-bold py-2 px-4 rounded" onClick={() => doMore()}>
                            More ...
                        </button>
                    </div>
                </div>
            </div>
            
            {showMore && (<div className='flex-col p-[5px] text-xs md:text-base'><hr/>{children}</div>)}

        </div>
    );
};

export default ProfileView;